import { DeliveryValidationResult } from '@epicuro-next/data/engagement/engagement-models';
import { ListProductReference } from '@epicuro-next/data/lists';

/**
 * This method calculates all the delivery info item totals
 * It doesn't filter depending on status.
 * To filter it, input should be adjuested
 *
 * @param deliveryInfos
 */
export const mapProductDeliveryInfoTotals = <
  T extends { quantity: number; price: number },
>(
  deliveryInfos: T[],
) =>
  deliveryInfos.reduce(
    (totals, deliveryInfo) => {
      const quantity = deliveryInfo.quantity ?? 0;
      const price = deliveryInfo.price ?? 0;
      return {
        totalRequestedQuantity: totals.totalRequestedQuantity + quantity,
        totalPrice: totals.totalPrice + quantity * price,
      };
    },
    {
      totalRequestedQuantity: 0,
      totalPrice: 0,
    },
  );

export function filterOutUnavailableDeliveryInfo(
  references: ListProductReference[],
): ListProductReference[] {
  return references.map((reference) => {
    if (!reference.deliveryInfo) return reference;

    const deliveryInfo = reference.deliveryInfo.filter(
      (info) => info.validationResult === DeliveryValidationResult.Available,
    );

    return {
      ...reference,
      ...mapProductDeliveryInfoTotals(deliveryInfo),
      deliveryInfo,
    };
  });
}
